import { useState } from "react";
import { cardToSpriteUrl } from "./helpers";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? "" : "");

/**
 * PokerCard — replica nativa de PokerCardPart.
 * Tamaños: 40x60 (detail view), 50x72 (board large).
 * Si no hay carta o falla la imagen, muestra el reverso.
 */
export function PokerCard({ slot, size = 40, faceDown = false, className = "", testId, dim = false }) {
  const w = size;
  const h = Math.round(size * 1.5);
  const url = !faceDown ? cardToSpriteUrl(BACKEND_URL, slot) : null;
  const backUrl = `${BACKEND_URL}/api/v2/native-ui/cards/back.png`;
  const [errored, setErrored] = useState(false);

  const finalUrl = !faceDown && url && !errored ? url : backUrl;

  return (
    <img
      src={finalUrl}
      alt={faceDown ? "face down" : (typeof slot === "string" ? slot : `${slot?.rank ?? "?"}${slot?.suit ?? ""}`)}
      style={{
        width: w,
        height: h,
        opacity: dim ? 0.32 : 1,
        filter: dim ? "grayscale(0.6) brightness(0.7)" : "none",
      }}
      className={`object-contain shrink-0 select-none transition-opacity ${className}`}
      draggable="false"
      loading="lazy"
      onError={() => setErrored(true)}
      data-testid={testId}
    />
  );
}
